module.exports = __webpack_public_path__ + "static/media/SAGE.1b93f5c3.png";